import React from "react";
import { Modal, ModalBody } from "reactstrap";
import AppMainButton from "../app_main_button/app_main_button";
import AppTransparentButton from "../app_transparent_button/app_transparent_button";
import {
  BrowserRouter as Router,
  Route,
  Link,
  withRouter,
} from "react-router-dom";
import "./app_dialog.css";
import GeneralBloc from "../../../bloc/general_bloc";
import Labels from "../../constant/labels";
import LanguageBloc from "../../../bloc/language_bloc";

class AppDialog extends React.Component {
  //props:title, description, buttonLabel
  constructor(props) {
    super(props);
    this.state = {
      isClosed: false,
    };
  }

  isOpen() {
    //if (this.state.isClosed === true) {
    //    return false;
    //}
    return this.props.isOpen ? this.props.isOpen : false;
  }

  componentDidMount() {}

  closeDialog = () => {
    this.setState(
      {
        isClosed: true,
      },
      () => {}
    );
  };

  render() {
    const boldText = {
      fontFamily: "OpenSans-Bold",
      fontSize: "24px",
      color: "#000000",
      marginBottom: "10px",
    };

    const noPadding = {
      padding: "0px",
      margin: "0px",
    };

    var btnLabel = this.props.buttonLabel;

    return (
      <Modal
        className="terms-modal"
        backdrop="static"
        size="lg"
        style={{ maxWidth: "540px", width: "96%" }}
        centered
        isOpen={this.isOpen()}
      >
        <ModalBody
          style={{ noPadding }}
          className="transaction_failed_modal_body"
        >
          <div className="row modal-body-content">
            <div className="col-md-12 text-left">
              {this.props.showClose == true && (
                <div style={{ "text-align": "right" }}>
                  <div>
                    <img
                      src={
                        GeneralBloc.getAssetsContextPath() +
                        `/assets/icons/valid_icon.svg`
                      }
                      style={{ marginBottom: "8px" }}
                      onClick={() => this.closeDialog()}
                    />
                  </div>
                </div>
              )}

              <div className="text-left dialog_title" dangerouslySetInnerHTML={{
                  __html: this.props.title,
                }}></div>

              {/* <div className="text-left" style={{ marginBottom: "32px" }}>
                                {this.props.description}
                            </div> */}
              <div
                className="text-center dialog_desc"
                dangerouslySetInnerHTML={{
                  __html: this.props.description,
                }}
              ></div>
               {
                this.props.hideButtons==true ? null :
                <div className="text-center">
               {
                 this.props.showCancelButton==true && <span className="mr-2">
                 {/* <AppMainButton
                    type={'inactive'}
                    enabled={true}
                    label={LanguageBloc.getTextByCode(Labels.BTN_CANCEL)}
                    icon={false}
                    shadow={'true'}
                    isBold={true}
                    onClick={(e) => {
                        this.closeDialog();
                        this.props.onClickCancel(e);
                    }} /> */}
                    <AppTransparentButton
                      label={LanguageBloc.getTextByCode(Labels.BTN_CANCEL)}
                      enable={true}
                      icon={false}
                      type={'inactive'}
                      shadow={'true'}
                      isBold={true}
                      onClick={(e) => {
                        this.closeDialog();
                        this.props.onClickCancel(e);
                      }}
                      style={{}}                      
                      />
                 </span>
                }
                               
                 <AppMainButton
                   label={this.props.buttonLabel || LanguageBloc.getEngOrBMText("Ok","Ok") }
                   enable={true}
                   onClick={(e) => {
                     this.closeDialog();
                     this.props.onClick(e);
                   }}
                   style={{}}
                   icon={false}
                 />
               </div>
               }
            </div>
          </div>
        </ModalBody>
      </Modal>
    );
  }
}

export default withRouter(AppDialog);
